import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { Input, InputField, Date, DateField, InlineGrid, InlineGridField } from '@components/form';
import { itemsColumns } from '@modules/requests/_requestsColumns';

const View: React.SFC<any> = _props => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={6}>
          <DateField component={Date} name={'validUntil'} label={'Platná do'} disabled={true} allowFuture={true} />
        </Col>
        <Col md={6}>
          <InputField component={Input} label="Vydáno od" name="issuedFromWarehouse.name" disabled={true} />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <h4>Předměty</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="items"
            columns={itemsColumns}
            showCheckboxes={true}
            deleting={false}
            adding={false}
            editing={false}
            version="3"
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);
export const RequestsFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/requests/requestsFormBasic.tsx